import MessageCtrl from './MessageCtrl';
import uiMask from 'angular-ui-mask';
export default angular.module('App.Message', [uiMask])
    
    .controller('MessageCtrl', MessageCtrl);


// WEBPACK FOOTER //
// ./src/app/modules/message/index.js